<template>
  <div v-if="hasApartment" class="col-span-full">
    <div class="flex flex-col gap-1 md:gap-4">
      <CardLoaderSmall v-if="isLoading" class="flex-1 flex-col ring-0" />
      <template v-else>
        <h2 class="text-t4 flex items-center gap-4">
          <IconEmail class="w-[50px] h-[50px] md:w-[59px] md:h-[59px]" />
          Meddelanden
        </h2>
        <div
          v-if="infoscreenMessages.length > 0"
          v-for="message in infoscreenMessages"
          class="grid grid-cols-1 overflow-hidden rounded-xl bg-white ring-1 ring-gray-light md:grid-cols-3"
        >
          <div v-if="message.Image" class="relative aspect-[341/192] md:col-span-1 md:aspect-auto">
            <img
              :src="'data:image/jpeg;base64,' + message.Image"
              class="absolute h-full w-full object-cover"
            />
          </div>
          <div class="flex flex-col gap-3 px-6 py-4 md:col-span-2">
            <p class="text-date font-bold uppercase text-gray-dark">
              {{ niceDateFormat(message.StartDate) }}
            </p>
            <h2 class="text-t5">{{ message.Title }}</h2>
            <Expandable :expanded="false">
              <template #default="{ toggle, expanded }">
                <div
                  v-if="!expanded"
                  class="line-clamp-2 [&_*]:inline [&_strong]:font-normal"
                  v-html="message.body_message"
                ></div>
              </template>
              <template #body="{ toggle, expanded }">
                <div class="flex flex-col gap-2" v-html="message.body_message"></div>
                <div v-if="message.body_images && message.body_images.length > 0">
                  <img v-for="img in message.body_images" :src="img.src" :alt="img.alt" />
                </div>
              </template>
              <template #readmore="{ toggle, expanded }">
                <Button variant="tertiary" @click="toggle(); if(!expanded){ dataLayerPushInt({'event':'messagesViewedMyPages', 'messagesTitleMyPages': message.Title });}" class="w-fit self-end">
                  <span v-if="!expanded">Visa mer</span>
                  <span v-else>Visa mindre</span>
                  <template #icon-after>
                    <IconChevronDown :class="[
                      'transition-transform duration-300',
                      expanded ? 'rotate-180' : 'rotate-0'
                    ]"/>
                  </template>
                </Button>
              </template>
            </Expandable>
          </div>
        </div>
        <Box v-else class="flex h-20 flex-1 flex-col items-center justify-center gap-2">
          <IconEmailBlank />
          <p class="text-center">Inga meddelanden att visa här just nu.</p>
        </Box>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dataLayerPush } from '@/helpers/datalayer';
import _ from 'lodash';
import dayjs from 'dayjs';
import Loader from '@/components/ui/loader';
import AppendableList from '@/components/ui/appendable-list';
import Expandable from '@/components/ui/expandable';
import Box from '@/components/ui/box';
import Button from '@/components/ui/button';
import IconChevronDown from '@/components/icons/IconChevronDown';
import IconEmail from '@/components/icons/IconEmail';
import IconEmailBlank from '@/components/icons/IconEmailBlank';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';

export default {
  name: 'DashboardInfoscreenMessages',
  components: {
    Loader,
    CardLoaderSmall,
    AppendableList,
    Expandable,
    IconChevronDown,
    IconEmailBlank,
    IconEmail,
    Button,
    Box,
  },
  props: {
    startLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loaded: [],
      isLoading: true,
      // testAlwaysLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      hasApartment: 'hasApartment',
      infoscreenMessages: 'infoscreenMessages',
    }),
  },
  watch: {
    startLoading: {
      immediate: true,
      handler(val) {
        if (val === true) {
          this.$store.cache.dispatch('getInfoscreenMessages').finally(() => {
            this.loaded.push('infoscreen');
            this.isLoading = false;
          });
        }
      }
    },
  },
  created() {
  },
  methods: {
    dataLayerPushInt(msg) {
      dataLayerPush(msg);
    },
    niceDateFormat(date) {
      return dayjs(date).format('DD MMMM YYYY');
    },
  },
};
</script>
